import * as React from "react"
import { RouteComponentProps } from "@gatsbyjs/reach-router"
import { SingleSignOn as SingleSignOnScreen } from "@modules/user/login/components/SingleSignOn"

export function SingleSignOn(props: RouteComponentProps) {
  return <SingleSignOnScreen {...props} />
}
